import React, { useState, useRef, useImperativeHandle, forwardRef } from "react";
import "./ImageCropViewWeb.css";
import { useDraggable } from "@neodrag/react";

/**
 * @param {object} props
 * @param {number} props.height
 * @param {number} props.width
 * @param {string} props.source
 * @param {number} [props.size]
 */
const ImageCropViewWeb = forwardRef((props, ref) => {
	const [imageWidth, setImageWidth] = useState(props.width || 0);
	const [imageHeight, setImageHeight] = useState(props.height || 0);
	// True only after onLoad has fired with the image's natural dimensions.
	// Bounds and dragging are intentionally locked until then.
	const [imageLoaded, setImageLoaded] = useState(false);
	const xRef = useRef(0);
	const yRef = useRef(0);
	const scaleVal = 1;
	const imageRef = useRef(null);

	let baseScale = 0;
	if (imageWidth && imageHeight)
		if (imageHeight > imageWidth)
			baseScale = props.size / imageWidth;
		else
			baseScale = props.size / imageHeight;


	// Only compute real drag bounds once the natural dimensions are confirmed via
	// onLoad. Before that, lock all sides to 0 so no movement is possible.
	const bounds = imageLoaded
		? {
			top: -((imageHeight * baseScale) - props.size),
			left: -((imageWidth * baseScale) - props.size),
			right: 0,
			bottom: 0,
		}
		: { top: 0, left: 0, right: 0, bottom: 0 };

	useDraggable(imageRef, {
		bounds: bounds,
		disabled: !imageLoaded,
		onDrag: ({ offsetX, offsetY }) => {
			xRef.current = -offsetX;
			yRef.current = -offsetY;
		},
	});

	useImperativeHandle(ref, () => ({
		getCurrentDim: () => ({
			scale: scaleVal,
			x: xRef.current,
			y: yRef.current,
		}),
	}));

	return (
		<div style={{ height: props.size, width: props.size }}>
			<img
				ref={imageRef}
				src={props.source}
				style={{
					width: baseScale * imageWidth,
					height: baseScale * imageHeight,
					cursor: "move",
				}}
				className="no-img-drag"
				onLoad={(e) => {
					setImageWidth(e.target.naturalWidth);
					setImageHeight(e.target.naturalHeight);
					setImageLoaded(true);
				}}
			/>
		</div>
	);
});

ImageCropViewWeb.displayName = "ImageCropViewWeb";

export default ImageCropViewWeb;
